import { RouteInfo } from "common/routes/route-info.interface";

export const createRoutes = <T extends Record<string, RouteInfo>>(
  routes: T
): { [K in keyof T]: RouteInfo } => routes;

export const isRouteInfo = (route: any): route is RouteInfo => {
  return route.hasOwnProperty("path");
};

/*flattens routes object to get all children RouteInfo as an array*/
export const flattenRoutes = (
  routes: Record<string, RouteInfo | Record<string, RouteInfo>>
): RouteInfo[] => {
  return Object.values(routes).flatMap(route =>
    isRouteInfo(route) ? route : flattenRoutes(route)
  );
};
